import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseInterface } from 'src/app/shared/interfaces/BaseInterface';

@Component({
  selector: 'app-modal-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent implements OnInit {
  public developmentFormGroup: FormGroup;

  @Input() public title: string;
  @Output() private emitCloseService = new EventEmitter<boolean>();
  @Output() private emitDismissService = new EventEmitter<boolean>();
  @Output() private emitCreateService = new EventEmitter<BaseInterface>();

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.createDevelopmentFormGroup();
  }

  private createDevelopmentFormGroup(): void {
    this.developmentFormGroup = this.formBuilder.group({
      name: ['', [Validators.required]],
      description: ['', []],
    });
  }

  public onClose(): void {
    this.emitCloseService.emit(true);
  }

  public onDismiss(): void {
    this.emitDismissService.emit();
  }

  public createBody(): BaseInterface {
    return {
      name: this.developmentFormGroup.get('name').value,
      description: this.developmentFormGroup.get('description').value,
    };
  }

  public createDevelopment(): void {
    if (this.developmentFormGroup.valid) {
      this.emitCreateService.emit(this.createBody());
      this.emitCloseService.emit(true);
    }
  }
}
